// extracted by mini-css-extract-plugin
export default {"row":"legacy-offers-actions_row__yz+Et","item":"legacy-offers-actions_item__8ywNA","placeOffer":"legacy-offers-actions_placeOffer__nK-Mw"};